import React from 'react';
import PayloadDescription from '../../components/PayloadDescription';

const Description = () => {
    return (
        <div>
            <p>
                <strong> Potential Payout</strong> is a helper that provides the
                utility of displaying the potential payout calculated for all
                types of bets (singles/multiples/system) including or not a
                reward.
            </p>
            <div>
                The <strong>getPotentialPayout()</strong> method accepts an
                object ({'{}'}) as parameter.
                <PayloadDescription />
            </div>
            <p>
                Below, there is an example of the input data that is used to
                display the <strong>potential payout</strong> value.
            </p>
        </div>
    );
};

export default Description;
